import { AdminChargeList } from '@/presentation/components/organisms/AdminChargeList';

export function Cuotas() {
  return <AdminChargeList />;
}
